import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import {isInitedSelector} from '../../modules/app'
import {isAdminSelector} from '../../modules/profile'
import {routesUrls} from '../../settings/routes'

const AdminRoute = ({ isInited, isAdmin, component: Component, ...rest }) => {
    if (!isInited) return <Route {...rest} render={props => (<Component {...props} />)} />
    return (
        <Route {...rest} render={props => (
            ( isAdmin ) ? (
                <Component {...props}/>
            ) : (
                <Redirect to={{
                    pathname: routesUrls.notFound,
                    state: { from: props.location }
                }}/>
            )
        )}/>
    )
}

export default connect(
    state=>({
        isInited : isInitedSelector(state),
        isAdmin : isAdminSelector(state),
    }),
    null,
    null,
    {pure:false}
)(AdminRoute)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/AdminRoute.js